
import axios from '../helper/api/index'
import phpHelper from '../helper/phpajax/index'


export const BaseDataService = {


    async getFlatBom(StockCode,Rout){ 

        let sendData = phpHelper.postObj("BomQueryUI","getFlatBom");
        sendData["StockCode"] = StockCode;
        sendData["Route"] = Rout;
        return await axios.post('ajax.php', sendData);
    },
    async getBom(StockCode,Rout){ 

        let sendData = phpHelper.postObj("BomQueryUI","getBom");
        sendData["StockCode"] = StockCode;
        sendData["Route"] = Rout;
        return await axios.post('ajax.php', sendData);
    },
    async getSOH(StockCode){ 

        let sendData = phpHelper.postObj("InvQueryUI","getSOH");
        sendData["StockCode"] = StockCode; 
        return await axios.post('ajax.php', sendData);
    },
    async getInvQuery(StockCode){ 

        let sendData = phpHelper.postObj("InvQueryUI","getInvQuery");
        sendData["StockCode"] = StockCode; 
        return await axios.post('ajax.php', sendData);
    },
    async getMedia(StockCode){ 

        let sendData = phpHelper.postObj("InvQueryUI","getMedia");
        sendData["StockCode"] = StockCode; 
        return await axios.post('ajax.php', sendData);
    },
    async searchMadeIn(StockCode){  
        return await axios.get('searchStockCode.php', { params: { search: StockCode }});
    },
    async searchPartCat(StockCode,category){  
        return await axios.get('searchStockCode.php', { params: { search: StockCode,category:category }});
    }

}
